import { paletteBase } from '@abg/kit-base';

import { SelectMfaFormBodyStyling } from './types';
export const selectMfaFormBodyStyling: SelectMfaFormBodyStyling = {
  description: {
    fontSize: '16px',
    lineHeight: '24px',
    color: paletteBase.secondary400,
  },
  title: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    minHeight: '40px',
    display: 'flex',
    alignItems: 'center',
    color: paletteBase.secondary400,
  },
  methodSelection: {
    radioGroup: {
      display: 'flex',
      flexDirection: 'column',
    },
    radio: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 5px',
    },
    radioBtn: {
      padding: '0',
      marginRight: '8px',
    },
    radioWithLabel: {
      margin: '0',
      lineHeight: '20px',
    },
    radioBtnInnerCircle: {
      width: '10px',
      height: '10px',
    },
    radioBtnOuterCircle: {
      width: '16px',
      height: '16px',
    },
    methodTitle: (isSelected: boolean) => ({
      fontWeight: isSelected ? 700 : 400,
      lineHeight: '20px',
      fontSize: '14px',
      display: 'inline-block',
    }),
    contactData: (isSelected: boolean) => ({
      color: isSelected ? paletteBase.black : paletteBase.neutral400,
      lineHeight: '16px',
      fontSize: '12px',
    }),
  },
};
